import { IOfferListModalLang } from '../../../types/lang'

export const offerListModalLang: IOfferListModalLang = {
	offer_list_modal: {
		title_bind: 'Binding offers to scope_ua',
		title_unbind: 'Unbinding offers from scope_ua',
		title_unscoped: 'Unscoped offers_ua',
		title_unscoped_in_group: 'Unscoped offers in group_ua',
		title_view: 'View offers in scope_ua',
		btn_close: 'Close_ua'
	}
}